import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Zap } from 'lucide-react';
import { useSettings } from '@/contexts/SettingsContext';

interface DemoModeIndicatorProps {
  showLabel?: boolean;
  className?: string;
}

export function DemoModeIndicator({ showLabel = true, className = '' }: DemoModeIndicatorProps) {
  const { isDemoMode } = useSettings();

  if (!isDemoMode) return null;

  return (
    <Badge 
      variant="secondary" 
      className={`bg-warning-muted text-warning border-warning/30 ${className}`}
    >
      <Zap className="h-3 w-3 mr-1" />
      {showLabel && 'Demo Mode'}
    </Badge>
  );
} 